
















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

import ElsaArviointiasteikonTaso from '../arviointiasteikon-taso/arviointiasteikon-taso.vue'

import ElsaButton from '@/components/button/button.vue'
import ElsaPagination from '@/components/pagination/pagination.vue'
import ElsaSearchInput from '@/components/search-input/search-input.vue'
import store from '@/store'
import { Arviointiasteikko, SuoriteRow, SuoritteenKategoriaRow } from '@/types'
import { ArviointiasteikkoTyyppi } from '@/utils/constants'

@Component({
  components: {
    ElsaArviointiasteikonTaso,
    ElsaButton,
    ElsaSearchInput,
    ElsaPagination
  }
})
export default class SuoritemerkintojenKategoriat extends Vue {
  @Prop({ required: true, default: undefined })
  kategoriat!: SuoritteenKategoriaRow[]

  @Prop({ required: true, default: undefined })
  arviointiasteikko!: Arviointiasteikko

  suoritemerkinnatCountByKategoria(kategoria: SuoritteenKategoriaRow) {
    return kategoria.suoritteet
      .map((a: SuoriteRow) => a.suoritettulkm || 0)
      .reduce((a, b) => a + b)
  }

  arviointiAsteikonNimi(arviointiasteikko: Arviointiasteikko) {
    return arviointiasteikko.nimi === ArviointiasteikkoTyyppi.EPA
      ? this.$t('luottamuksen-taso')
      : this.$t('etappi')
  }

  get account() {
    return store.getters['auth/account']
  }
}
